import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OrgprojecteditService } from './service/orgprojectedit.service';
import { Project } from '@src/app/models/project';
// import { Projectinterest } from '../orgprojectinterestadd/model/projectinterest';
import { Customer } from '../orgprojectadd/model/customer';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Customerdeal } from '@src/app/models/customerdeal';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalService } from '@src/app/helpers/modal.service';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgprojectedit',
  templateUrl: './orgprojectedit.component.html',
  styleUrls: ['./orgprojectedit.component.css']
})
export class OrgprojecteditComponent implements OnInit, OnChanges {
  @Input() wizard: boolean;
  @Input() @Output() project:Project;
  @Output() projecttoupdate = new EventEmitter<Project>();
  // projectintersttoadd:Projectinterest;
  //customerList:Customer[];
  dealList:Customerdeal[];
  @Input() dealId:string;
  @Input() customerId:string;
  errorMessage:string;
  updateMessage:string;

  constructor(
    private tasrv:OrgprojecteditService,
    private modalservice:ModalService,
  ) { }

  ngOnInit() {
    if(!this.project){  this.project = new Project; }
    // this.tasrv.getCustomers().pipe(untilDestroyed(this)).subscribe(clist => {
    //   this.customerList = clist;
    //   this.sortCustomers();
      
    // });
    if(this.project.customer != undefined){
      this.setCustomer(this.project.customer);
    }

  }
  // sortCustomers(){
  //   this.customerList = this.customerList.sort((a,b)=> {
  //     if(a.title.toLowerCase() < b.title.toLowerCase()) { return -1; }
  //     if(a.title.toLowerCase() > b.title.toLowerCase()) { return 1; }
  //     return 0;
  //   });
  // }
  ngOnChanges(changes: SimpleChanges){
    if(changes.project && changes.project.currentValue && changes.project.currentValue != changes.project.previousValue){
      this.project = changes.project.currentValue;
      if(this.project.customer != undefined){
        this.setCustomer(this.project.customer);
      }
    //console.log('project for edit',this.project)
 
    }
  }
  setCustomer(customerId:string){
    //get deals for customer
    this.tasrv.getDeals(customerId,new Date().toISOString()).pipe(untilDestroyed(this)).subscribe(deals => {
      this.dealList = deals;
      
    });
  }

  closeModal(){
    this.modalservice.close('orgProjectEditModal');
  }
  updateProject(){
    if(!this.project.title || !this.project.end_date || !this.project.start_date || !this.project.projectdescription){
      this.errorMessage = "modalvalidation.requiredfieldmissing";
    }else{
      this.errorMessage = "";
    //this.project.customername = this.customerList[this.customerList.findIndex(cust => cust.customerId.split('_')[0] == this.project.customer.split('_')[0])].title;
    //console.log(this.project.customername);
    this.tasrv.updateProject(this.project).pipe(untilDestroyed(this)).subscribe(result => {
      this.project.projectId = result;
      //console.log('project updated',this.project);
      
      this.projecttoupdate.emit(this.project);
      this.updateMessage = "Project updated!";
      this.closeModal();
    },(error)=>{
      //console.log('ERROR: ',error);

    });}
  }
  // addInterest(projectInterestTooAdd:Projectinterest){
  //   this.projectintersttoadd = projectInterestTooAdd;
  // }

}
